import { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

import { ToastAccessory } from "./types";

type ResolveToastAccessoryArgs = {
  accessory?: ToastAccessory;
  Icon?: React.FC<SVGIconProps>;
};

/**
 * Resolves the leading toast accessory from `accessory` or the deprecated `Icon` prop.
 * Prefer `accessory` when both are provided.
 */
export const resolveToastAccessory = ({
  accessory,
  Icon,
}: ResolveToastAccessoryArgs): ToastAccessory | undefined => {
  if (accessory != null && Icon != null) {
    // oxlint-disable-next-line no-console
    console.error(
      "Toast: both `accessory` and deprecated `Icon` were provided. Using `accessory` and ignoring `Icon`."
    );
  }

  if (accessory != null) {
    return accessory;
  }

  if (Icon != null) {
    return { type: "icon", Icon };
  }

  return undefined;
};
